/* eslint-disable react/display-name */
import React from 'react'
import cn from 'classnames'

import PanelGroup from 'components/PaneGroup'
import RightSidebar from 'components/App/DesktopView/Layout/RightSidebar'
import MainCell from 'components/App/DesktopView/Layout/MainCell'
import HelplyCopilotPanel from 'components/App/DesktopView/Layout/HelplyCopilotPanel'
import withPanelWidthManager from 'components/App/DesktopView/Layout/withPanelWidthManager'
import TicketList from 'subapps/ticketing/components/TicketList'

import RightSidebarToggler from '../../RightSidebar/Toggler'
import useRightSidebar from '../../RightSidebar/useRightSidebar'
import styles from '../styles.css'

import {
  applyCopilotPanelWidth,
  keepStoredSidebarWidth,
} from '../copilotPanelWidth'
import OverlayBackground from './OverlayBackground'
import { DEFAULT_WIDTHS, DEFAULT_BREAKPOINTS, STORAGE_KEY } from './defaults'
import { styles as emotionStyles } from './styles'

class ModernView extends React.PureComponent {
  // Length has to match panes count
  componentWrappers = [
    React.forwardRef((props, ref) => {
      return (
        <div
          {...props}
          ref={ref}
          className={cn(props.className, 'hidden-in-print')}
        />
      )
    }),
    null,
    React.forwardRef((props, ref) => {
      const { isRightSidebarCollapsed, overlay } = this.props
      const { onTransitionEnd, finalStyle } = useRightSidebar({
        isRightSidebarCollapsed,
        overlay,
        style: props.style,
      })

      return (
        <div
          {...props}
          ref={ref}
          onTransitionEnd={onTransitionEnd}
          style={finalStyle}
          className={cn(
            props.className,
            styles.rightSidebarWrapper,
            'hidden-in-print'
          )}
        />
      )
    }),
  ]

  render() {
    const {
      toggleRightSidebar,
      isBulkSelectionMode,
      isRightSidebarCollapsed,
      isHelplyCopilotOpen,
      overlay,
      ticketId,
      panelWidths = [],
      panelUpdateCallback,
    } = this.props

    const showRightSideBar = !isBulkSelectionMode && ticketId
    const isRightSidebarHiddenOrCollapsed =
      isRightSidebarCollapsed || !showRightSideBar
    const collapsedPanels = isRightSidebarHiddenOrCollapsed
      ? (panelWidths.length - 1).toString()
      : ''
    // In overlay mode (narrow screens) the sidebar floats over the editor and
    // takes no layout space, so widening it wouldn't clear the copilot drawer.
    const isCopilotDocked =
      isHelplyCopilotOpen && showRightSideBar && ticketId !== 'new' && !overlay
    const effectivePanelWidths = isCopilotDocked
      ? applyCopilotPanelWidth(panelWidths)
      : panelWidths
    // Only guard persistence when the sidebar width is actually forced —
    // an already-wide-enough sidebar stays freely resizable and persistable.
    const isSidebarWidthForced = effectivePanelWidths !== panelWidths
    const handlePanelUpdate = isSidebarWidthForced
      ? updatedWidths =>
          panelUpdateCallback(
            keepStoredSidebarWidth(updatedWidths, panelWidths)
          )
      : panelUpdateCallback
    return (
      <>
        {showRightSideBar && <RightSidebarToggler />}
        <PanelGroup
          css={emotionStyles.paneGroup}
          spacing={0}
          panelWidths={effectivePanelWidths}
          collapsedPanels={collapsedPanels}
          onUpdate={handlePanelUpdate}
          ComponentWrappers={this.componentWrappers}
          breakpoints={DEFAULT_BREAKPOINTS}
          className="four-column-view"
        >
          <TicketList channelType="mailbox" />
          <MainCell />
          {showRightSideBar && (
            <RightSidebar
              panelWidth={(effectivePanelWidths[2] || {}).size}
              overlay={overlay}
            />
          )}
        </PanelGroup>
        <OverlayBackground
          onClick={toggleRightSidebar}
          visible={overlay && !isRightSidebarCollapsed}
        />
        <HelplyCopilotPanel />
      </>
    )
  }
}

export default withPanelWidthManager(DEFAULT_WIDTHS, STORAGE_KEY)(ModernView)
